/**
 * Marketplace buyurtma kontraktlari (Faza 4) — savat → checkout → fulfillment.
 *
 * Multi-seller: bitta MarketplaceOrder → N ERP Order (har sotuvchi do'koni).
 * Fulfillment ikki fazali: RESERVE (stok band) → CONFIRM (ERP Order, locked decrement).
 * Pul DTO'larda STRING (Decimal → string).
 */
import { z } from 'zod';
import { uuidSchema } from './common.schema.js';
import { returnConditionEnum } from './order.schema.js';
// ─── Checkout (buyer yuboradi) ────────────────────────────────────
export const checkoutItemSchema = z.object({
    offerId: uuidSchema,
    quantity: z.number().int().min(1, 'Soni 1 dan kam emas').max(1000),
    // Mahsulot xili tanlangan bo'lsa — Product.variants[] pozitsiyasi (0-indexli).
    // Xilli mahsulotda MAJBURIY (server tekshiradi); xilsiz mahsulotda yuborilmaydi.
    variantIndex: z.number().int().min(0).max(49).optional(),
});
export const checkoutSchema = z
    .object({
    items: z.array(checkoutItemSchema).min(1, 'Kamida 1 mahsulot').max(50),
    deliveryType: z.enum(['delivery', 'pickup']),
    addressId: uuidSchema.optional(),
    pickupPointId: uuidSchema.optional(), // Faza 5
    paymentMethod: z.enum(['cod', 'card']),
    note: z.string().trim().max(500).optional(),
    promoCode: z.string().trim().max(40).optional(), // Faza 6 — chegirma
    // Idempotency kaliti — client har checkout URINISHI uchun bitta uuid yuboradi.
    // Double-submit/tarmoq-retry'da server MAVJUD buyurtmani qaytaradi (yangisini
    // yaratmaydi). Ixtiyoriy (eski clientlar ishlashda davom etadi).
    clientRequestId: uuidSchema.optional(),
})
    .refine((d) => d.deliveryType !== 'delivery' || d.addressId !== undefined, {
    message: 'Yetkazib berish uchun manzil tanlang',
    path: ['addressId'],
})
    .refine((d) => d.deliveryType !== 'pickup' || d.pickupPointId !== undefined, {
    message: 'Olib ketish uchun punkt tanlang',
    path: ['pickupPointId'],
});
// Sotuvchi buyurtmani bajaradi/bekor qiladi (POS Order.status o'tishi).
export const fulfillOrderSchema = z.object({
    status: z.enum(['COMPLETED', 'CANCELLED']),
});
// Sotuvchi marketplace buyurtmani QAYTARADI (POS Order.status → RETURNED).
//   - condition=YAROQLI  → mahsulot stokka qaytadi (sotuvga tayyor)
//   - condition=YAROQSIZ → brak (DefectiveProduct), stokka qaytmaydi
export const returnFulfillmentSchema = z.object({
    condition: returnConditionEnum,
    reason: z.string().trim().min(1, 'Sabab kerak').max(1000),
});
// Marketplace fulfillment navbati — query (status filtri + pagination).
export const fulfillmentQuerySchema = z.object({
    status: z.enum(['PENDING', 'COMPLETED', 'CANCELLED', 'RETURNED', 'all']).optional(),
    // Yashirish filtri: undefined/false → faqat ko'rinadigan (faol ro'yxat);
    // true → faqat yashirilgan ("Tarix" tab).
    hidden: z.coerce.boolean().optional(),
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(100).default(20),
});
// Buyurtmani ro'yxatdan yashirish / tiklash (soft-dismiss, o'chirish EMAS).
export const setOrderVisibilitySchema = z.object({
    hidden: z.boolean(),
});
//# sourceMappingURL=marketplace-order.schema.js.map